import { render } from "./FriendButton.vue?vue&type=template&id=3d1a61a8"
import script from "./FriendButton.vue?vue&type=script&lang=js"
export * from "./FriendButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__